// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__UiMZ0","insightsList":"newBusinessInsightsMenu_insightsList__1q3cd","active":"newBusinessInsightsMenu_active__2qqJX"};